import { render, staticRenderFns } from "./KCLogin.vue?vue&type=template&id=c655374a&scoped=true&"
import script from "./KCLogin.vue?vue&type=script&lang=js&"
export * from "./KCLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c655374a",
  null
  
)

export default component.exports